import {
  AchRepository,
  AchTransfer,
  AdminRepository,
  AdminTransfer,
  BookRepository,
  BookTransfer,
  CreateAchTransfer,
  CreateBookTransfer,
  CreateFXQuoteRequest,
  CreateIntlWireTransfer,
  CreateRealtimeTransfer,
  CreateWireTransfer,
  CryptoRepository,
  CryptoTransfer,
  FxQuote,
  FxRateSheet,
  IntlWireRepository,
  IntlWireTransfer,
  RealtimeRepository,
  RealtimeTransfer,
  TransferFilterParams,
  TransferListResponse,
  TransferRepository,
  WireDrawdownRepository,
  WireRepository,
  WireTransfer,
} from '~/repositories';
import { CheckRepository, CheckTransfer } from '~/repositories/Transfer/CheckRepository';
import { WireDrawdownRequest } from '~/typings/API';

import { RepositoryMethod, createApiHook } from './utils/createApiHook';

export type TransferID =
  | 'ach'
  | 'wire'
  | 'book'
  | 'intl-wire'
  | 'check'
  | 'realtime'
  | 'wire-drawdown'
  | 'admin'
  | 'crypto';
export type TransferType =
  | AchTransfer
  | WireTransfer
  | BookTransfer
  | IntlWireTransfer
  | CheckTransfer
  | RealtimeTransfer
  | WireDrawdownRequest
  | AdminTransfer
  | CryptoTransfer;
type TransferResponse = (params: GetRequestType) => Promise<TransferType>;

export type TransferFilterType = TransferFilterParams & {
  page?: number;
  pageIndex?: number;
  query?: string;
};

const TransferMethods = new Map<TransferID, TransferResponse>([
  ['ach', AchRepository.get],
  ['wire', WireRepository.get],
  ['book', BookRepository.get],
  ['intl-wire', IntlWireRepository.get],
  ['check', CheckRepository.get],
  ['realtime', RealtimeRepository.get],
  ['wire-drawdown', WireDrawdownRepository.get],
  ['admin', AdminRepository.get],
  ['crypto', CryptoRepository.get],
]);

export const useTransfer = <T>(type: TransferID, triggerAutomatically: boolean = true) =>
  createApiHook<T, GetRequestType>(TransferMethods.get(type) as RepositoryMethod<T, GetRequestType>, {
    triggerAutomatically,
    triggerOnSessionStoreSubscribe: triggerAutomatically,
  });

export const useTransfersFetch = createApiHook<TransferListResponse, TransferFilterType>(TransferRepository.getAll);

export const useCreateACHTransfer = createApiHook<AchTransfer, CreateAchTransfer>(AchRepository.create);

export const useCreateWireTransfer = createApiHook<WireTransfer, CreateWireTransfer>(WireRepository.create);

export const useCreateBookTransfer = createApiHook<BookTransfer, CreateBookTransfer>(BookRepository.create);

export const useCreateIntlWireTransfer = createApiHook<IntlWireTransfer, CreateIntlWireTransfer>(
  IntlWireRepository.create
);

export const useFxRateSheet = createApiHook<FxRateSheet, unknown>(IntlWireRepository.getFxRateSheet);

export const useCreateFxQuote = createApiHook<FxQuote, CreateFXQuoteRequest>(IntlWireRepository.createFxQuote);

export const useCreateRealtimeTransfer = createApiHook<RealtimeTransfer, CreateRealtimeTransfer>(
  RealtimeRepository.create
);
